import { initFromDom } from './photoswipe-init';
import { ajaxPost, validators } from './util';

document.addEventListener('DOMContentLoaded', () => {
  initFromDom('.picture-gallery');

  let $hamburger = document.getElementById('hamburger');
  let $navMenu = document.getElementById('nav');
  let $mainContent = document.getElementById('content');
  let $contactForm = document.getElementById('contactForm');
  let $contactFormSubmitButton = document.getElementById('contactFormSubmitButton');
  let $contactSuccess = document.getElementById('contactSuccess');
  let $captcha = document.getElementById('captcha');

  $hamburger.addEventListener('click', (evt) => {
    $hamburger.classList.toggle('opened');
    $navMenu.classList.toggle('opened');
    $mainContent.classList.toggle('shim');
  }, false);

  if ($contactForm) {
    const _validate = () => {
      let $requiredFields = document.getElementsByClassName('required');
      return [...$requiredFields].reduce((valid, field) => {
        let validator = field.getAttribute('validator');
        let input = field.getElementsByTagName('input')[0];
        let isFieldValid = validators[validator](input.value);
        field.classList.toggle('error', !isFieldValid);
        return valid && isFieldValid;
      }, true);
    };

    $contactForm.addEventListener('submit', (evt) => {
      evt.preventDefault();

      if (!_validate()) return;

      const captcha = grecaptcha.getResponse();

      const captchaValid = !!captcha && captcha.length > 0;
      $captcha.classList.toggle('error', !captchaValid);
      if (!captchaValid) return;

      const form = $contactForm;
      var params = [].filter.call(form.elements, function (el) {
        return !!el.name;
      }).map(function (el) {
        return `${encodeURIComponent(el.name)}=${encodeURIComponent(el.value)}`;
      }).join('&');
      params += `&captcha=${captcha}`;

      $contactForm.classList.toggle('processing');
      $contactFormSubmitButton.disabled = true;
      ajaxPost(form.action, params, () => {
        $contactSuccess.classList.toggle('success');
        $contactForm.classList.toggle('success');
      });
    });
  }
});



// WEBPACK FOOTER //
// ./app.js